import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ducks } from '../../..';
import { useDebounce } from '../../../hooks';
import { Wrapper } from '../styled';
import ModalHeader from '../components/ModalHeader';
import AccountsListView from '../components/AccountsListView';
import ModalNavigation from '../components/ModalNavigation';
import BottomButtons from '../components/BottomButtons';
const UpgradeWithPaymentModal = ({ translations, isMobileView, currentUserEmail, organizationActiveUsers, areActiveUsersLoading, organizationPaymentUsers, onClose, onDetailsButtonClick, onHaveActivationCodeButtonClick, ORGANIZATION_PAYMENT_ACTIONS: { SELECT_USER, UNSELECT_USER, SELECT_ALL_USERS, UNSELECT_ALL_USERS, }, ORGANIZATION_ACTIVE_USERS_ACTIONS: { REQUEST }, }) => {
    const [allChecked, setAllChecked] = useState(false);
    const [searchText, setSearchText] = useState(null);
    const [accountsList, setAccountsList] = useState(null);
    const numberOfSelectedUsers = organizationPaymentUsers && organizationPaymentUsers.length;
    const handleSearchBarChange = (e) => {
        setSearchText(e.target.value);
    };
    const handleChangeUserForPaymentState = (user, state) => {
        if (state) {
            SELECT_USER(user);
        }
        else {
            UNSELECT_USER(user);
        }
    };
    const handleChangeAllUsersForPaymentState = (users, state) => {
        if (state) {
            SELECT_ALL_USERS(users);
        }
        else {
            UNSELECT_ALL_USERS();
        }
    };
    useDebounce(() => {
        if (searchText !== null)
            REQUEST({ searchText });
    }, 350, [searchText]);
    useEffect(() => {
        if (!areActiveUsersLoading) {
            if (!organizationPaymentUsers ||
                (Array.isArray(organizationPaymentUsers) &&
                    organizationPaymentUsers.length === 0)) {
                setAccountsList(organizationActiveUsers
                    ? organizationActiveUsers.map((organizationUser) => (Object.assign(Object.assign({}, organizationUser), { checked: false })))
                    : null);
                return;
            }
            setAccountsList(organizationActiveUsers.map((organizationUser) => {
                return Object.assign(Object.assign({}, organizationUser), { checked: !!organizationPaymentUsers.find((paymentUser) => paymentUser.boxExternalId === organizationUser.boxExternalId) });
            }));
        }
    }, [organizationActiveUsers, organizationPaymentUsers]);
    return (React.createElement(Wrapper, { className: "modal-plans" },
        React.createElement(ModalNavigation, { onModalClose: onClose, shouldBeBackButton: false }),
        React.createElement(ModalHeader, { translations: translations.modalHeader, handleSearchBarChange: handleSearchBarChange, checked: allChecked, onCheckBoxClick: (e) => {
                handleChangeAllUsersForPaymentState(accountsList, e.target.checked);
                setAllChecked(!allChecked);
            }, onHaveActivationCodeButtonClick: onHaveActivationCodeButtonClick, numberOfSelectedUsers: numberOfSelectedUsers, isUpgradeWithPaymentView: true, isMobileView: isMobileView }),
        React.createElement(AccountsListView, { translations: translations.accountsListView, accountsList: accountsList, currentUserEmail: currentUserEmail, handleChangeUserForPaymentState: handleChangeUserForPaymentState, isUpgradeWithPaymentView: true, isMobileView: isMobileView, areAccountsLoading: areActiveUsersLoading }),
        React.createElement(BottomButtons, { translations: translations.bottomButtons, onCancelButtonClick: onClose, onMainButtonClick: onDetailsButtonClick })));
};
export const mapStateToProps = (state) => {
    return {
        organizationActiveUsers: state.organizationActiveUsers.get('data'),
        areActiveUsersLoading: state.organizationActiveUsers.get('isProcessing'),
        organizationPaymentUsers: state.organizationPayment.get('selectedUsers'),
    };
};
export const mapDispatchToProps = (dispatch) => ({
    ORGANIZATION_PAYMENT_ACTIONS: bindActionCreators(ducks.ORGANIZATION_PAYMENT_ACTIONS, dispatch),
    ORGANIZATION_ACTIVE_USERS_ACTIONS: bindActionCreators(ducks.ORGANIZATION_ACTIVE_USERS_ACTIONS, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(UpgradeWithPaymentModal);
